import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT, SERVICES, waLink } from "@/data/site";

const EXPLORE = [
  ["Home", "/", "home"],
  ["About Us", "/about-us-luxury-spa", "about"],
  ["Services", "/services-luxury-spa", "services"],
  ["Membership", "/membership-luxury-spa", "membership"],
  ["Contact Us", "/contact-us-luxury-spa", "contact"],
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold/10 bg-[#0A090B]">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div className="space-y-5">
          <Logo />
          <p className="text-sm leading-relaxed text-stone-400">
            A sanctuary of body massage and Jacuzzi hydrotherapy in Suchitra, Hyderabad — where every session is a return to yourself.
          </p>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-gold/80">Explore</h4>
          <ul className="space-y-3 text-sm text-stone-300">
            {EXPLORE.map(([label, to, id]) => (
              <li key={id}>
                <Link to={to} data-testid={`footer-link-${id}`} className="transition-colors hover:text-gold">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-gold/80">Services</h4>
          <ul className="space-y-3 text-sm text-stone-300">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services-luxury-spa/${s.slug}`}
                  data-testid={`footer-service-${s.slug}`}
                  className="transition-colors hover:text-gold"
                >
                  {s.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-gold/80">Visit Us</h4>
          <ul className="space-y-4 text-sm text-stone-300">
            <li className="flex gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
              <span data-testid="footer-address">{CONTACT.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="shrink-0 text-gold" />
              <a href={CONTACT.phoneTel} data-testid="footer-phone" className="transition-colors hover:text-gold">
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li className="flex gap-3">
              <span className="shrink-0 text-gold">
                <WhatsAppIcon size={16} />
              </span>
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="transition-colors hover:text-gold"
              >
                WhatsApp us anytime
              </a>
            </li>
            <li className="flex gap-3">
              <Clock size={16} className="shrink-0 text-gold" />
              <span data-testid="footer-hours">{CONTACT.hours}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gold/10 py-6 text-center text-xs tracking-wide text-stone-500">
        © {new Date().getFullYear()} Belong Saloon and Spa · Suchitra, Hyderabad · Crafted for rest
      </div>
    </footer>
  );
}
